import * as React from 'react';
import {Banner} from '@sail/ui';
import {useIntl} from '@sail/intl';
import {useFlag} from '@sail/access';
import type {MessageKeys} from './messages';
import {messages} from './messages';
import {useConnectJsOptionsContext} from '../../data-layer-client/ConnectJsOptionsContext/useConnectJsOptionsContext';
import type {ConnectElementImportKeys} from '../../connect/ConnectJSInterface/ConnectElementList';

export const DevNotice = ({
  type,
  connectElement,
  showOnlyInLoginAs,
}: {
  type: MessageKeys;
  connectElement: ConnectElementImportKeys;
  showOnlyInLoginAs?: boolean;
}) => {
  const intl = useIntl();
  const {
    values: {metaOptions},
  } = useConnectJsOptionsContext();
  const enablesDevNotices = useFlag('enable_dev_notices');
  const hostApp = metaOptions?.hostApp;
  const isLoginAs = hostApp && hostApp === 'loginAs';

  const message = messages[type];

  if (
    isLoginAs ||
    ((process.env.NODE_ENV === 'development' || enablesDevNotices) &&
      !showOnlyInLoginAs)
  ) {
    return (
      <Banner
        type="default"
        title={intl.formatMessage(messages.title)}
        description={intl.formatMessage(message, {connectElement})}
        data-testid="dev-notice-banner"
      />
    );
  }

  return null;
};
